import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {ProjectRoleDirective} from '@components/project-participants/project-role'
import {useUserCardStore} from './user-card-store'

export const UserCardProjects = observer(() => {
  const [state, store] = useUserCardStore()

  return (
    <div className="prj-invite__participate">
      <div className="prj-invite__participate-title">
        {Lang.msg.permission.participateProjects}:
      </div>
      <div className="prj-invite__participate-header">
        <div className="prj-invite__participate-header-proj">
          {Lang.msg.permission.headerProject}
        </div>
        <div className="prj-invite__participate-header-role">
          {Lang.msg.permission.headerRole}
        </div>
      </div>

      <div className="prj-invite__participate-list">
        {state.projects.map(project => (
          <div className="prj-invite__participate-item" key={project.id}>
            <label className="prj-users-ch">
              <input
                type="checkbox"
                className="_checkbox"
                checked={!!state.chosenProjects[project.id]}
                onChange={() => store.toggleProject(project)}
              />
              <span className="_checkbox" />
              <span className="prj-invite__item-text">{project.title}</span>
            </label>

            {!!state.chosenProjects[project.id] && (
              <div className="prj-invite-role">
                <ProjectRoleDirective
                  role={state.chosenProjects[project.id]}
                  projectId={project.id}
                  setRole={store.setRole}
                  close={store.close}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
})
